import React, { Fragment, useEffect,useContext,useState} from "react";
import {useParams,useHistory  } from "react-router-dom";
import {pathOr,isEmpty,propOr,map,has} from 'ramda';

import { Context } from "./Utility/store";
import { apiInstance } from "./Utility/axios";
import { ShareTeamPlayer } from "./Utility/actionMethod";
import {getFormattedTrends} from "./Utility/FormattedTrends";
import { date } from "yup";


const ProfileSharing = () => {
let history = useHistory();
const { id1 } = useParams();
const { id2 } = useParams();
const { id3 } = useParams();
const {name1} = useParams();
const {name2} = useParams();
const {name3} = useParams();
const {position1} = useParams();
const {position2} = useParams();
const {position3} = useParams();
const { gameType } = useParams();
const {  pttype } = useParams();
const {  onechart } = useParams();


const [state,dispatch] = useContext(Context);
const [ChartData,setChartData] = useState([]);
const [ProfileData, setProfileData] = useState([]);
    
const hitters = ['3B', 'CF', 'SS', '2B', 'C', '1B', 'RF', 'LF', 'DH', 'OF']
const pitchers = ['P', 'SP', 'RP']


var isrun = true;
let selected_cat = gameType;
let type = pttype;

const user_setting = '{"player":{"exclusive_stats":{"hitter":{"BABIP":false,"ISO":false,"BB%":false,"LD%":false,"FB%":false,"GB%":false,"HR/FB":false,"GBFB":false,"K%":false},"pitcher":{"K/9":false,"K/BB":false,"H/9":false,"IRA":false,"BQR":false,"BQR-S":false,"PO":false,"P/IP":false,"HR/9":false,"BB/9":false},"passing":{"air_yards":true,"avg_pocket_time":true,"hurries":true,"knockdowns":true,"on_target_throws":true,"redzone_attempts":true,"dropped_passes":true},"rushing":{"yards_after_catch":true,"yards_after_contact":true,"broken_tackles":true,"redzone_targets":true,"Scrambles":true},"receiving":{"air_yards":true,"broken_tackles":true,"dropped_passes":true,"targets":true,"redzone_targets":true,"yards_after_catch":true,"yards_after_contact":true},"defense":{"batted_passes":true,"hurries":true,"knockdowns":true,"qb_hits":true,"safeties":true},"field_goals":{"attempts":true,"blocked":true,"longest":true},"nba":{"EFF_EX":true,"TSP_EX":true,"FTR_EX":true,"EFP_EX":true,"FBP_EX":true,"PPP_EX":true,"SCP_EX":true}},"season_stats":{"hitter":{"G":true,"AB":true,"R":true,"H":true,"HR":true,"twoB":true,"threeB":true,"RBI":true,"BB":true,"SO":true,"SB":true,"CS":true,"AVG":true,"OBP":true,"SLG":true,"OPS":true},"pitcher":{"G":true,"W":true,"L":true,"ERA":true,"SV":true,"SVO":true,"IP":true,"H":true,"R":true,"ER":true,"HR":true,"HB":true,"BB":true,"IBB":true,"SO":true,"WHIP":true},"passing":{"COMP":true,"PATT":true,"PYDS":true,"PAVG":true,"PTD":true,"INT":true,"SCK":true,"QBR":true,"RATT":true,"RYDS":true,"RAVG":true,"RTD":true,"FUM":true,"LOST":true},"rushing":{"RATT":true,"RYDS":true,"RAVG":true,"LNG":true,"RTD":true,"REC":true,"REYDS":true,"REAVG":true,"RETD":true},"receiving":{"REC":true,"YDS":true,"REAVG":true,"TD":true,"LNG":true,"TGT":true},"defense":{"AST":true,"TOT":true,"SACK":true,"SCKYADS":true,"TFL":true,"PD":true,"INT":true,"FR":true},"field_goals":{"ATT":true,"M":true,"MI":true,"PCT":true,"LNG":true,"EM":true,"EPCT":true},"nba":{"GP":true,"MIN":true,"PTS":true,"REB":true,"ASTT":true,"TOV":true,"STL":true,"BLK":true,"FGM":true,"FGA":true,"FGP":true,"THPM":true,"THPA":true,"THPP":true,"FTA":true,"FTP":true,"PF":true,"DDT":true,"TDTH":true}},"next_game":{"show_next_game":true},"player_trends":{"show_player_trends":true}},"team":{"exclusive_stats":{"hitter":{"BABIP":false,"ISO":false,"BB%":false,"LD%":false,"FB%":false,"GB%":false,"HR/FB":false,"GBFB":false,"K%":false},"pitcher":{"K/9":false,"K/BB":false,"H/9":false,"IRA":false,"BQR":false,"BQR-S":false,"PO":false,"P/IP":false,"HR/9":false,"BB/9":false},"passing":{"air_yards":true,"avg_pocket_time":true,"hurries":true,"knockdowns":true,"on_target_throws":true,"redzone_attempts":true,"dropped_passes":true},"rushing":{"yards_after_catch":true,"yards_after_contact":true,"broken_tackles":true,"redzone_targets":true,"Scrambles":true},"receiving":{"air_yards":true,"broken_tackles":true,"dropped_passes":true,"targets":true,"redzone_targets":true,"yards_after_catch":true,"yards_after_contact":true},"defense":{"batted_passes":true,"hurries":true,"knockdowns":true,"qb_hits":true,"safeties":true},"field_goals":{"attempts":true,"blocked":true,"longest":true},"nba":{"EFF_EX":true,"TSP_EX":true,"FTR_EX":true,"EFP_EX":true,"FBP_EX":true,"PPP_EX":true,"SCP_EX":true}},"season_stats":{"hitter":{"G":true,"AB":true,"R":true,"H":true,"HR":true,"twoB":true,"threeB":true,"RBI":true,"BB":true,"SO":true,"SB":true,"CS":true,"AVG":true,"OBP":true,"SLG":true,"OPS":true},"pitcher":{"G":true,"W":true,"L":true,"ERA":true,"SV":true,"SVO":true,"IP":true,"H":true,"R":true,"ER":true,"HR":true,"HB":true,"BB":true,"IBB":true,"SO":true,"WHIP":true},"passing":{"COMP":true,"PATT":true,"PYDS":true,"PAVG":true,"PTD":true,"INT":true,"SCK":true,"QBR":true},"rushing":{"RATT":true,"RYDS":true,"RAVG":true,"LNG":true,"RTD":true},"receiving":{"REC":true,"YDS":true,"REAVG":true,"TD":true,"LNG":true,"TGT":true},"defense":{"AST":true,"TOT":true,"SACK":true,"SCKYADS":true,"TFL":true,"PD":true,"INT":true,"FR":true},"field_goals":{"ATT":true,"M":true,"MI":true,"PCT":true,"LNG":true,"EM":true,"EPCT":true},"nba":{"GP":true,"PTS":true,"REB":true,"ASTT":true,"TOV":true,"STL":true,"BLK":true,"FGM":true,"FGA":true,"FGP":true,"THPM":true,"THPA":true,"THPP":true,"FTA":true,"FTP":true,"PF":true}},"next_game":{"show_next_game":true},"player_trends":{"show_player_trends":true}}}'
const id = [];
id.push(id1);
if(id2 !== undefined){
    id.push(id2);
}
if(id3 !== undefined){
    id.push(id2);
}




// useEffect(() => {
//     localStorage.setItem("user_setting",user_setting);
//     localStorage.setItem("category_type",gameType);
//     localStorage.setItem("ishare",true);
//     if(pttype === "player"){
//         localStorage.setItem("isteam",false);
//     }else{
//         localStorage.setItem("isteam",true);
//     }

//         ShareTeamPlayer(dispatch,'nfl','player',data,state);     
//     setTimeout(() => {
//         history.push("/player-profile"); 
//     }, 3000);
    
//   },[]);



  





const getChartData = async (name,position) => {
    let response = "";
    var id =id1;
    
    let playername = name;
    let playerPosition = position;
    if(id !== ''){
      try {
        if (selected_cat === "nfl") {
          response = await apiInstance.get(selected_cat +"/" + type +"/" +id +"/game_statistics?season_type=REG");
          
        } else if (selected_cat === "mlb") {
          response = await apiInstance.get(selected_cat +"/" +type +"/" +id +"/game_summary?num_recent_games=10");
        } else {
          response = await apiInstance.get(selected_cat + "/" + type + "/" + id + "/game_summary?season_type=REG");
        }
       if(response){
          let chartResponse = getFormattedTrends(response, playerPosition, type, 2, playername, selected_cat);
         console.log(chartResponse);
          var chartArr = [];
          if(type === "player"){
            if(selected_cat ===  "nfl"){
              chartResponse.dates.map((number,index) =>
              chartArr.push(
                { 
                  DATE:number,
                  TRENDS : chartResponse.trends
                })
              );
                setProfileData(chartResponse.profileNameColor);
                var msg = {chartArr:chartArr}
                localStorage.setItem("onePT", JSON.stringify(msg));
                dispatch({type: 'CHARTDATA', payload:msg}) 
                setChartData(chartArr);  
                console.log("msg",msg);
            }
            
            if(selected_cat ===  "nba"){
            chartResponse.dates.map((number,index) =>
            chartArr.push(
              { 
                DATE:number,
                TRENDS : chartResponse.trends
              })
            );
            setProfileData(chartResponse.profileNameColor);
            var msg = {'chartArr':chartArr}
            localStorage.setItem("onePT", JSON.stringify(msg));
            dispatch({type: 'CHARTDATA', payload:msg})  
            setChartData(chartArr); 
            } 
      
            if(selected_cat ===  "mlb"){
              let chartArr = [];
              
              if (hitters.includes(playerPosition)) {
              
                chartResponse.dates.map((number,index) =>
                  chartArr.push(
                    { 
                      DATE:number,
                      TRENDS : chartResponse.trends
                    })
                  );
                  setProfileData(chartResponse.profileNameColor);
                  var msg = {'chartArr':chartArr}
                  localStorage.setItem("onePT", JSON.stringify(msg));
                  dispatch({type: 'CHARTDATA', payload:msg})
                  setChartData(chartArr); 
                 
              }
              if (pitchers.includes(playerPosition)) {
                  chartResponse.dates.map((number,index) =>
                  chartArr.push(
                    { 
                      DATE:number,
                      TRENDS : chartResponse.trends
                    })
                  );
                  setProfileData(chartResponse.profileNameColor);
                  var msg = {'chartArr':chartArr}
                  localStorage.setItem("onePT", JSON.stringify(msg));
                  dispatch({type: 'CHARTDATA', payload:msg})
                  setChartData(chartArr); 
              }
        
            
            
            }
            
          
            }else{
            if(selected_cat ===  "nfl"){
              if(chartResponse !== undefined){
              var chartArrpass = [];
              chartResponse.passing.dates.map((number,index) =>
              chartArrpass.push(
                { 
                  DATE:number,
                  TRENDS : chartResponse.passing.trends
                })
              );
  
              var chartArrrush = [];
              chartResponse.rushing.dates.map((number,index) =>
              chartArrrush.push(
                { 
                  DATE:number,
                  TRENDS : chartResponse.rushing.trends
                })
              );
              
              var chartArrrecei = [];
              chartResponse.receiving.dates.map((number,index) =>
              chartArrrecei.push(
                { 
                  DATE:number,
                  TRENDS : chartResponse.receiving.trends
                })
              );
            
  
                var chartArrDefense = [];
                chartResponse.defense.dates.map((number,index) =>
                chartArrDefense.push(
                  { 
                    DATE:number,
                    TRENDS : chartResponse.defense.trends
                  })
                );
                 
  
                var chartArrfield_goals = [];
                chartResponse.field_goals.dates.map((number,index) =>
                chartArrfield_goals.push(
                  { 
                    DATE:number,
                    TRENDS : chartResponse.field_goals.trends
                  })
                );
                  setProfileData(chartResponse.profileNameColor);
                  var msg ={ passing:chartArrpass, 
                              rushing: chartArrrush,
                              receiving:chartArrrecei,
                              defense:chartArrDefense,
                              field_goals:chartArrfield_goals
                            }       
                  dispatch({type: 'CHARTDATA', payload:msg}) 
                  setChartData(msg); 
                  localStorage.setItem("onePT", JSON.stringify(msg));
  
              }
            
            }else if (selected_cat ===  "mlb"){
              if(chartResponse !== undefined){
              let hittingArr = [];
              let pitchingArr = [];
              
              
                chartResponse.hitting.dates.map((number,index) =>
                  hittingArr.push(
                    { 
                      DATE:number,
                      TRENDS : chartResponse.hitting.trends
                    })
                  );
  
              
                  chartResponse.pitching.dates.map((number,index) =>
                  pitchingArr.push(
                    { 
                      DATE:number,
                      TRENDS : chartResponse.pitching.trends
                    })
                  );
             
                  console.log('pitchingArr',pitchingArr)
              setProfileData(chartResponse.profileNameColor);
              var msg = {hitting:hittingArr,pitching:pitchingArr}
              console.log("msg", msg)
              localStorage.setItem("onePT", JSON.stringify(msg));
              dispatch({type: 'CHARTDATA', payload:msg})
              setChartData(msg);
  
            }
            }else{
              chartResponse.nba.dates.map((number,index) =>
              chartArr.push(
                { 
                  DATE:number,
                  TRENDS : chartResponse.trends
                })
              );
              setProfileData(chartResponse.profileNameColor);
              var msg = {'nba':chartArr}
              localStorage.setItem("onePT", JSON.stringify(msg));
              dispatch({type: 'CHARTDATA', payload:msg}) 
              setChartData(msg);
            }
          }
        }
      
      } catch (err) {
        console.log(err);
      }
    }
    
  };


const getChartData2 = async () => {
  let response = "";
  let id = id2;
  let playername = name2;
  let playerPosition = position2;

  // if (playerTeamInfo.length === 2) {
  //   id = pathOr("", ["1", "id"], playerTeamInfo);
  //   playername = pathOr("", ["1", "name"], playerTeamInfo);
  //   playerPosition = pathOr("", ["1", "position"], playerTeamInfo);
  // }
  // if (playerTeamInfo.length === 3) {
  //   id = pathOr("", ["2", "id"], playerTeamInfo);
  //   playername = pathOr("", ["2", "name"], playerTeamInfo);
  //   playerPosition = pathOr("", ["2", "position"], playerTeamInfo);
  // }

  if (id !== "") {
    try {
      if (selected_cat === "nfl") {
        response = await apiInstance.get(
          selected_cat +
            "/" +
            type +
            "/" +
            id +
            "/game_statistics?season_type=REG"
        );
      } else if (selected_cat === "mlb") {
        response = await apiInstance.get(
          selected_cat +
            "/" +
            type +
            "/" +
            id +
            "/game_summary?num_recent_games=10"
        );
      } else {
        response = await apiInstance.get(
          selected_cat +
            "/" +
            type +
            "/" +
            id +
            "/game_summary?season_type=REG"
        );
      }
      if (response) {
        const res = response.data.response[0];
        let chartResponse = getFormattedTrends(
          response,
          playerPosition,
          type,
          2,
          playername,
          selected_cat
        );

        var chartArr = [];

        if (type === "player") {
          if (selected_cat === "nfl") {
            chartResponse.dates.map((number, index) =>
              chartArr.push({
                DATE: number,
                TRENDS : chartResponse.trends
              })
            );

            setProfileData(chartResponse.profileNameColor);
            var msg = { chartArr: chartArr };
            dispatch({ type: "CHARTDATA", payload: msg });
            if (localStorage.getItem("twoPT") === "") {
              localStorage.setItem("twoPT", JSON.stringify(msg));
            }

            setChartData(chartArr);
          }

          if (selected_cat === "nba") {
            chartResponse.dates.map((number, index) =>
              chartArr.push({
                DATE: number,
                TRENDS : chartResponse.trends
              })
            );
            setProfileData(chartResponse.profileNameColor);
            var msg = { chartArr: chartArr };
            if (localStorage.getItem("twoPT") === "") {
              localStorage.setItem("twoPT", JSON.stringify(msg));
            }
            dispatch({ type: "CHARTDATA", payload: msg });
            setChartData(chartArr);
          }

          if (selected_cat === "mlb") {
            let chartArr = [];

            if (hitters.includes(playerPosition)) {
              chartResponse.dates.map((number, index) =>
                chartArr.push({
                  DATE: number,
                  TRENDS : chartResponse.trends
                })
              );
              setProfileData(chartResponse.profileNameColor);
              var msg = { chartArr: chartArr };
              if (localStorage.getItem("twoPT") === "") {
                localStorage.setItem("twoPT", JSON.stringify(msg));
              }
              dispatch({ type: "CHARTDATA", payload: msg });
              setChartData(chartArr);
            }
            if (pitchers.includes(playerPosition)) {
              chartResponse.dates.map((number, index) =>
                chartArr.push({
                  DATE: number,
                  TRENDS : chartResponse.trends
                })
              );

              setProfileData(chartResponse.profileNameColor);
              var msg = { chartArr: chartArr };
              if (localStorage.getItem("twoPT") === "") {
                localStorage.setItem("twoPT", JSON.stringify(msg));
              }
              dispatch({ type: "CHARTDATA", payload: msg });
              setChartData(chartArr);
            }
          }
        } else {
          if (selected_cat === "nfl") {
            if (chartResponse !== undefined) {
              var chartArrpass = [];

              chartResponse.passing.dates.map((number, index) =>
                chartArrpass.push({
                  DATE: number,
                  TRENDS : chartResponse.passing.trends
                })
              );

              var chartArrrush = [];
              chartResponse.rushing.dates.map((number, index) =>
                chartArrrush.push({
                  DATE: number,
                  TRENDS : chartResponse.rushing.trends
                })
              );

              var chartArrrecei = [];
              chartResponse.receiving.dates.map((number, index) =>
                chartArrrecei.push({
                  DATE: number,
                  TRENDS : chartResponse.receiving.trends
                })
              );

              var chartArrDefense = [];
              chartResponse.defense.dates.map((number, index) =>
                chartArrDefense.push({
                  DATE: number,
                  TRENDS : chartResponse.defense.trends
                })
              );

              var chartArrfield_goals = [];
              chartResponse.field_goals.dates.map((number, index) =>
                chartArrfield_goals.push({
                  DATE: number,
                  TRENDS : chartResponse.field_goals.trends
                })
              );
              setProfileData(chartResponse.profileNameColor);
              var msg = {
                passing: chartArrpass,
                rushing: chartArrrush,
                receiving: chartArrrecei,
                defense: chartArrDefense,
                field_goals: chartArrfield_goals,
              };
              if (localStorage.getItem("twoPT") === "") {
                localStorage.setItem("twoPT", JSON.stringify(msg));
              }

              setChartData(msg);
              dispatch({ type: "CHARTDATA", payload: msg });
            }
          } else if (selected_cat === "mlb") {
            if (chartResponse !== undefined) {
              let hittingArr = [];
              let pitchingArr = [];

              chartResponse.hitting.dates.map((number, index) =>
                hittingArr.push({
                  DATE: number,
                  TRENDS : chartResponse.hitting.trends
                })
              );

              chartResponse.pitching.dates.map((number, index) =>
                pitchingArr.push({
                  DATE: number,
                  TRENDS : chartResponse.pitching.trends
                })
              );

              setProfileData(chartResponse.profileNameColor);
              var msg = { hitting: hittingArr, pitching: pitchingArr };
              dispatch({ type: "CHARTDATA", payload: msg });
              if (localStorage.getItem("twoPT") === "") {
                localStorage.setItem("twoPT", JSON.stringify(msg));
              }
              setChartData(msg);
            }
          } else {
            chartResponse.nba.dates.map((number, index) =>
              chartArr.push({
                DATE: number,
                TRENDS : chartResponse.nba.trends
              })
            );
            setProfileData(chartResponse.profileNameColor);
            var msg = { nba: chartArr };
            dispatch({ type: "CHARTDATA", payload: msg });
            if (localStorage.getItem("twoPT") === "") {
              localStorage.setItem("twoPT", JSON.stringify(msg));
            }
            setChartData(msg);
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  }
};



useEffect(async() => {
    localStorage.setItem("user_setting",user_setting);
    localStorage.setItem("category_type",gameType);
    localStorage.setItem("ishare",true);
    localStorage.setItem("islogged",false);
    localStorage.setItem("twoPT","");
    if(pttype === "player"){
        localStorage.setItem("isteam",false);
    }else{
        localStorage.setItem("isteam",true);
    }
    if(isrun){
        isrun = false;
    console.log("isrunfalse",isrun);
    localStorage.setItem("playerteamInfo","");

    if(id.length === 1){
        ShareTeamPlayer(dispatch,gameType,pttype,id1,state)
        setTimeout(() => {
             history.push("/player-profile"); 
        }, 3000);
    }

    if(id.length === 2){
        getChartData(name1,position1);
        await ShareTeamPlayer(dispatch,gameType,pttype,id1,state)
        ShareTeamPlayer(dispatch,gameType,pttype,id2,state).then(()=>{
                setTimeout(() => {
                    history.push("/player-comparision"); 
                }, 3000);
            }) 
        
    }

    if(id.length === 3){
      getChartData(name1,position1);
      getChartData2();
        await ShareTeamPlayer(dispatch,gameType,pttype,id1,state)
           ShareTeamPlayer(dispatch,gameType,pttype,id2,state).then(()=>{
                    ShareTeamPlayer(dispatch,gameType,pttype,id3,state).then(()=>{
                        setTimeout(() => {
                            history.push("/player-comparision"); 
                        }, 3000);
                }) 
            }) 
        
    }
}



        // ShareTeamPlayer(dispatch,'nfl','player',id1,state).then(()=>{
        //     ShareTeamPlayer(dispatch,'nfl','player',id1,state).then(()=>{
        //         ShareTeamPlayer(dispatch,'nfl','player',id1,state).then(()=>{
            
        //         }) 
        //     }) 
        // })  
    // setTimeout(() => {
    //     history.push("/player-profile"); 
    // }, 3000);
    
  },[]);

const loadingCenter ={
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}

const loadingText = {
    fontSize:'50px',
    color:"#2B7D3E"
}

  return (
  <Fragment>
    <div style={loadingCenter}>
        <p style={loadingText}>Loading...</p>
    </div>
    </Fragment>
  );
};

export default ProfileSharing;
